import Vue from 'vue';
import Router from 'vue-router';
import routes from './route'

// 跳转相同路由，浏览器控制台报错处理
["push", "replace"].forEach(methodName => {
    const method = Router.prototype[`${methodName}`];
    Router.prototype[`${methodName}`] = function (location) {
        return method.call(this, location).catch(error => error);
    };
});

Vue.use(Router);

// 创建router对象
const router = new Router({
    routes
});

// 全局前置守卫，用于权限拦截
// router.beforeEach((to, from, next) => {


//     next()
// });

export default router;